import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

export const lightningStrikeLegendPerLevel = (t, level) => {
  return [
    `${t("levels.noData")} : (ld < 0)`,
    `${t("levels.low")} : (0 ≤ ld < 8)`,
    `${t("levels.moderate")} : (8 ≤ ld < 12)`,
    `${t("levels.significant")} : (12 ≤ ld < 18)`,
    `${t("levels.high")} : (18 ≤ ld < 24)`,
    `${t("levels.veryHigh")} : (ld ≥ 24)`,
  ][level];
};

export const lightningStrikeLegendLevels = () => {
  return [0, 8, 12, 18, 24, 100];
  // 5 numerical intervals for normal legend (1,2,3,4,5)
  // Other values are considered as "no data"
};

const LightningStrikeLegend = () => {
  const { t } = useTranslation();

  return (
    <div style={legendStyle}>
      <div>
        <b>{t("legend.lightningStrikeDensity")} (ITA)</b>
      </div>
      <div>
        <span style={legendItemStyle("#2b83ba")}></span>
        {lightningStrikeLegendPerLevel(t, 1)}
      </div>
      <div>
        <span style={legendItemStyle("#abdda4")}></span>
        {lightningStrikeLegendPerLevel(t, 2)}
      </div>
      <div>
        <span style={legendItemStyle("#ffffbf")}></span>
        {lightningStrikeLegendPerLevel(t, 3)}
      </div>
      <div>
        <span style={legendItemStyle("#fdae61")}></span>
        {lightningStrikeLegendPerLevel(t, 4)}
      </div>
      <div>
        <span style={legendItemStyle("#d7191c")}></span>
        {lightningStrikeLegendPerLevel(t, 5)}
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          ld = {t("legend.lightningAverageEventsNumber")}.
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar - {t("legend.dataFromNOAAandNWS")}
        </span>
      </div>
    </div>
  );
};

export default LightningStrikeLegend;
